import { render, staticRenderFns } from "./DeactivateCustomer.vue?vue&type=template&id=13d28f9d&scoped=true"
import script from "./DeactivateCustomer.vue?vue&type=script&lang=js"
export * from "./DeactivateCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d28f9d",
  null
  
)

export default component.exports